<div class="calendar-arrows">
  <button class="calendar-arrows__arrow" (click)="onPrev.emit(true)">
    <svg-icon [src]="'/assets/img/ic-arrow-down-blue.svg'" [svgClass]="'rotate-90'"></svg-icon>
  </button>
  <button class="calendar-arrows__arrow" (click)="onNext.emit(true)">
    <svg-icon [src]="'/assets/img/ic-arrow-down-blue.svg'" [svgClass]="'rotate--90'"></svg-icon>
  </button>
</div>
